module.exports = __webpack_public_path__ + "img/contenedor15.3f3505d4.png";